module.exports = __webpack_public_path__ + "static/media/05.Connection Box.160044c2.JPG";